/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish
 * File Description: Actions file for login user
 */

/* eslint-disable no-console */

import axios from 'axios';

import { appUrl, smlUrl } from '../../utils/config';

import { deleteAuthToken } from '../../utils/setAuthToken';

import {
  USER_LOGOUT,
  RESET_USER_PASSWORD,
  RESET_PASS_TOKEN_DETAILS,
  RESET_PASSWORD_FINAL,
  GET_ISSUE_TYPE,
  REQUEST_CONTACT_ADMIN,
  SESSION_TIMEOUT,
  SESSION_TIMEOUT_SETTINGS,
  USER_PROFILE,
  ORG_PROFILE,
  FETCH_DEPARTMENT_DETAILS,
  UPDATE_DEPARTMENT_DETAILS,
  FETCH_DEPARTMENT_DETAILS_LOADING,
  UPDATE_ORG_PROFILE,
  FETCH_USERFROM_DEPT_LOADING,
  FETCH_USERFROM_DEPT,
} from './types';

import {
    OPEN_BACKDROP,
    DESTROY_BACKDROP
} from '../../components/pcmp/containers/actions/types';

export const getResetPasswordTokenDetails = (data, history) => (dispatch) => {
  axios
    .post(`${smlUrl}/user/verifyResetPasswordToken`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: RESET_PASS_TOKEN_DETAILS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      // console.log(err.response)
      if (err.response.status === 403) {
        history.push('/deactivateduser')
      }
      else {
        history.push('/pageNotFound');
      }
    });
};

export const userConfirmResetPassword = (data, history) => (dispatch) => {
  axios
    .post(`${smlUrl}/user/resetPassword`, data)
    .then((res) => {
      if (res.data.status === true) {
        // dispatch({
        //   type: RESET_PASSWORD_FINAL,
        //   payload: res.data,
        // });
        history.push('/resetpasswordcompleted');
      }
    })
    .catch((err) => {
      if (err.response.status === 400) {
        dispatch({
          type: RESET_PASSWORD_FINAL,
          payload: err.response.data,
        });
      }
    });
};
// Reset Password
export const resetPassword = (data) => (dispatch) => {
  axios
    .post(`${smlUrl}/user/sendResetPasswordInvitation`, data)
    .then((res) => {
      dispatch({
        type: RESET_USER_PASSWORD,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: RESET_USER_PASSWORD,
        payload: err.response.data,
      });
    });
};

export const userContactAdmin = (data, history) => (dispatch) => {
  axios
    .post(`${smlUrl}/user/contactAdmin`, data)
    .then((res) => {
      history.push(`/requestmailsent?email=${data.email}`);
    })
    .catch((err) => {
      if (err.response.status === 500) {
        history.push('/error500');
      } else {
        dispatch({
          type: REQUEST_CONTACT_ADMIN,
          payload: err.response.data,
        });
      }
    });
};
export const sessionTimeout = (history) => (dispatch) => {
  axios
    .get(`${smlUrl}/user/sessionTimeOut`)
    .then((res) => {
      dispatch({
        type: SESSION_TIMEOUT,
        payload: res.data,
      });
      localStorage.removeItem('authToken');
      deleteAuthToken();
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: SESSION_TIMEOUT,
        payload: err.response.data,
      });
    });
};
export const userIssueType = () => (dispatch) => {
  axios
    .get(`${smlUrl}/user/fetchContactAdminIssues`)
    .then((res) => {
      dispatch({
        type: GET_ISSUE_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

// Session time out settings
export const sessionTimeoutSettings = () => (dispatch) => {
  axios
    .get(`${smlUrl}/admin/getsessiontime`)
    .then((res) => {
      if (res.data.status === true) {
        console.log('got session time');
        dispatch({
          type: SESSION_TIMEOUT_SETTINGS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// User Logout
export const userLogout = (history) => (dispatch) => {
  axios
    .get(`${smlUrl}/user/logout`)
    .then((res) => {
      if (res.data.status === true) {
        console.log('User logged out');
      }
    })
    .catch((err) => {
      console.log(err);
    });
  // clear tokens and other data from local storage
  localStorage.removeItem('authToken');
  localStorage.removeItem('network');
  localStorage.removeItem('organizationName');
  localStorage.removeItem('accountType');
  localStorage.removeItem('collabType');
  localStorage.removeItem('ecosystemId');
  localStorage.removeItem('ecosystem_name');
  localStorage.removeItem('roleName');
  localStorage.removeItem('selectedDateFormat');
  localStorage.removeItem('userType');
  localStorage.removeItem('appName');
  localStorage.removeItem('departmentId');
  localStorage.removeItem('fileUploadedProducts');
  localStorage.removeItem('selectedSupplyView');


  // clear session data
  sessionStorage.clear();

  // remove default header auth token in Axios
  deleteAuthToken();
  // if (history.location.pathName !== '/login') {
  //push user to login
  history.push('/login');
  dispatch({
    type: USER_LOGOUT,
  });
};

//-------**--V2.0 User and Org Profile--**--------------
// user profile
export const userProfileData = () => (dispatch) => {
  axios
    .get(`${smlUrl}/user/getUserProfile`)
    .then((res) => {
      dispatch({
        type: USER_PROFILE,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
// update user profile
export const updateUserProfile = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: 'Please Wait. Updating the profile picture',
  });

  axios
    .post(`${smlUrl}/user/updateUserProfile`, data)
    .then((res) => {
     
      if (res.data.status === true) {
        dispatch({
          type: USER_PROFILE,
          payload: res.data,
        });
        dispatch({
          type: DESTROY_BACKDROP
        });
      } else {
        console.log('data not updated');
        dispatch({
          type: DESTROY_BACKDROP
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: DESTROY_BACKDROP
      });
    });
};

// organization profile
export const orgProfileData = () => (dispatch) => {
  axios
    .get(`${smlUrl}/user/getOrganizationDetails`)
    .then((res) => {
      dispatch({
        type: ORG_PROFILE,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

// update org profile
export const updateOrgProfile = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: 'Please Wait. Updating the organization profile',
  });

  axios
    .post(`${smlUrl}/user/updateOrganizationDetails`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: UPDATE_ORG_PROFILE,
          payload: res.data,
        });
        dispatch({
          type: DESTROY_BACKDROP
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: DESTROY_BACKDROP
      });
    });
};


export const fetchDepartmentDetails = () => (dispatch) => {
  axios
    // .get(`${smlUrl}/user/fetchDepartmentDetails`)
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDepartmentDetails`)
    .then((res) => {
      dispatch({
        type: FETCH_DEPARTMENT_DETAILS_LOADING,
        payload: false,
      });
      dispatch({
        type: FETCH_DEPARTMENT_DETAILS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_DEPARTMENT_DETAILS_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_DEPARTMENT_DETAILS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_DEPARTMENT_DETAILS_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_DEPARTMENT_DETAILS,
          payload: {
            status: false,
            errorDescription:
              'Something went wrong. Please contact Schrocken Support.',
          },
        });
      }
    });
};

export const fetchUserfromDepartment = () => (dispatch) => {
  axios
    // .get(`${smlUrl}/user/fetchDepartmentDetails`)
    .get(
      `${appUrl}/user/fetchUserfromDepartment`)
    .then((res) => {
      dispatch({
        type: FETCH_USERFROM_DEPT_LOADING,
        payload: false,
      });
      dispatch({
        type: FETCH_USERFROM_DEPT,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_USERFROM_DEPT_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_USERFROM_DEPT,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_USERFROM_DEPT_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_USERFROM_DEPT,
          payload: {
            status: false,
            errorDescription:
              'Something went wrong. Please contact Schrocken Support.',
          },
        });
      }
    });
};

export const updateDepartmentDetails = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: `Please don't refresh or close the tab while processing`,
  });
  axios
    // .post(`${smlUrl}/user/updateDepartmentDetails`, data)
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDepartmentDetails`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_DEPARTMENT_DETAILS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      if (err?.response?.status === 400) {
        console.log('err', err.response.data);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_DEPARTMENT_DETAILS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_DEPARTMENT_DETAILS,
          payload: {
            status: false,
            errorDescription:
              'Something went wrong. Please contact schrocken support.',
          },
        });
      }
    });
};


